<script>
  import PageTitle from '$lib/components/PageTitle.svelte';
  import Page from '$lib/components/Page';
  import { getStores } from '$app/stores';

  const { page } = getStores();

  $: dev = $page.data.session.env.PRODUCT !== 'production';
</script>

<PageTitle title={$page.status} />

<Page>
  <h1 data-cy='page-status'>{$page.status}</h1>

  <p data-cy='page-error-msg'>{$page?.error.message}</p>

  {#if dev && $page?.error.stack}
    <pre>{$page?.error.stack}</pre>
  {/if}
</Page>

<style>
  h1,
  p {
    margin: 0 auto;
  }

  h1 {
    font-size: 2.8em;
    font-weight: 700;
    margin: 0 0 0.5em 0;
  }

  p {
    margin: 1em auto;
  }

  @media (min-width: 480px) {
    h1 {
      font-size: 4em;
    }
  }
</style>
